import { render, staticRenderFns } from "./formAuditEmailAlerts.vue?vue&type=template&id=1003070f&"
import script from "./formAuditEmailAlerts.vue?vue&type=script&lang=js&"
export * from "./formAuditEmailAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports